import {Component} from '@angular/core';

@Component({
  selector: 'app-shared-widget-container-component',
  imports: [],
  templateUrl: './shared-widget-container.component.html',
  styleUrl: './shared-widget-container.component.scss',
})
export class SharedWidgetContainerComponent {
}
